import { networkClient } from './client';
import type { ApiEnvelope } from './types';

export type TopTransferDirection = 'in' | 'out';

export interface BETopTransferPlayer {
  rank: number;
  playerId: string;
  displayName: string;
  position: string;
  clubName: string | null;
  clubShortName: string | null;
  shirtKey: string | null;
  opponentShortNames: string[];
  currentValue: number;
  transferCount: number;
  direction: TopTransferDirection;
}

export interface TopTransfersData {
  gameweek: { id: string; number: number } | null;
  transferredIn: BETopTransferPlayer[];
  transferredOut: BETopTransferPlayer[];
}

export type TopTransfersResponse = ApiEnvelope<TopTransfersData>;

export const fetchTopTransfers = (tournamentCalendarId: string): Promise<TopTransfersResponse> =>
  networkClient
    .get<TopTransfersResponse>('/api/stats-centre/top-transfers', {
      params: { tournamentCalendarId },
    })
    .then(({ data }) => data);
